import * as jwt from "jsonwebtoken";

export const generateBrowserToken = (salt, expiresIn) =>
  jwt.sign({ warning: "For Internal CJ Use Only" }, salt, {
    algorithm: "HS256",
    expiresIn,
  });
